/* iKrush cart drawer Add-ons row: Lucky Dip tile plus one-tap jewellery. Plain script, no build step. */
(function () {
  "use strict";

  var DEFAULT_PRICE_PENCE = 500;
  var HOLDOUT_PERCENT = 10;
  var SEED_KEY = "ikrush_ld_seed";
  /* Whole words only, so "Flattering" or "Courtney" do not read as footwear. */
  var FOOTWEAR_WORDS = /\b(boots?|sandals?|heel(?:s|ed)?|trainers?|sneakers?|loafers?|mules?|wedges?|courts?|stilettos?|pumps?|shoes?|flatforms?|sliders?|espadrilles?|gladiators?|plimsolls?|brogues?|ballets?|flip|flats?)\b/i;

  /* "UK 5" -> "5", " 5.5 " -> "5.5". Returns "" for anything else. */
  function normaliseShoeSize(size) {
    var match = String(size == null ? "" : size).trim().match(/^(?:uk\s*)?(\d(?:\.5)?)$/i);
    if (!match) return "";
    var n = parseFloat(match[1]);
    return n >= 2 && n <= 9 ? match[1] : "";
  }

  function isShoeLine(line) {
    line = line || {};
    var size = normaliseShoeSize(line.size);
    if (!size) return false;
    var n = parseFloat(size);
    var oddOrHalf = n % 2 !== 0;
    var text = (line.productType || "") + " " + (line.title || "");
    return oddOrHalf || FOOTWEAR_WORDS.test(text);
  }

  function isLuckyDipLine(line) {
    return /lucky\s*dip/i.test((line && line.title) || "");
  }

  /*
   * Clothing dip size for one cart size. The store mostly labels clothing S/M, M/L, L/XL or "ONE SIZE (8 - 16)";
   * UK numbers also appear: 4-10 -> S/M, 12+ -> M/L. Returns "" when nothing fits.
   */
  var SMALL_LETTER_SIZES = ["XS", "S", "M", "XS/S", "S/M"];
  var LARGE_LETTER_SIZES = ["L", "XL", "M/L", "L/XL"];

  function clothingDipSize(size) {
    var text = String(size == null ? "" : size).trim().toUpperCase();
    if (/^(ONE\s*SIZE|1\s*SZE)/.test(text)) return "1SZE";
    var letters = text.replace(/\s+/g, "");
    if (SMALL_LETTER_SIZES.indexOf(letters) !== -1) return "S/M";
    if (LARGE_LETTER_SIZES.indexOf(letters) !== -1) return "M/L";
    var match = text.match(/^(?:UK\s*)?(\d{1,2})$/);
    if (!match) return "";
    var n = parseInt(match[1], 10);
    if (n >= 4 && n <= 10) return "S/M";
    if (n >= 12) return "M/L";
    return "";
  }

  /* First cart line with a real size wins; one-size lines (scarves, bags) are only the fallback. */
  function clothingDipSizeFor(lines) {
    var fallback = "";
    for (var i = 0; i < lines.length; i++) {
      var mapped = clothingDipSize(lines[i] && lines[i].size);
      if (mapped === "1SZE") fallback = fallback || mapped;
      else if (mapped) return mapped;
    }
    return fallback;
  }

  function selectOffer(input) {
    input = input || {};
    var lines = input.lines || [];
    if (!lines.length) return null;
    if (lines.some(isLuckyDipLine)) return null;

    var dips = input.dips || {};
    var shoeLine = lines.filter(isShoeLine)[0];
    var dip = shoeLine ? dips.footwear : dips.clothing;
    if (!dip || !dip.variants) return null;

    var variants = dip.variants.filter(function (v) { return v && v.available; });
    if (!variants.length) return null;

    var wantedSize = shoeLine ? normaliseShoeSize(shoeLine.size) : clothingDipSizeFor(lines);
    var preselected = null;
    for (var i = 0; i < variants.length; i++) {
      if (wantedSize && String(variants[i].size) === wantedSize) { preselected = variants[i].id; break; }
    }

    var pricePence = Number(variants[0].pricePence) || DEFAULT_PRICE_PENCE;
    var gapPence = freeDeliveryGap(input);

    return {
      handle: dip.handle,
      image: typeof dip.image === "string" && dip.image ? dip.image : null,
      variants: variants,
      preselectedVariantId: preselected,
      pricePence: pricePence,
      message: offerMessage(gapPence, pricePence),
      gapPence: gapPence
    };
  }

  function freeDeliveryGap(input) {
    return Math.max(0, (Number(input.thresholdPence) || 0) - (Number(input.totalPence) || 0));
  }

  function offerMessage(gapPence, pricePence) {
    if (gapPence > 0 && gapPence <= pricePence) {
      return "You're " + formatPounds(gapPence) + " from free delivery. Add a Lucky Dip and it's free.";
    }
    return "Add a surprise piece for " + formatPounds(pricePence, { wholeWithoutDecimals: true }) + ".";
  }

  /*
   * One-tap add-ons for the cart row. Liquid hands over the cart-add-ons collection in best-selling order;
   * this keeps that order and drops anything already in the bag, anything over the price cap and anything unaddable.
   */
  var ADD_ON_MAX_PRICE_PENCE = 1500;
  var ADD_ON_DEFAULT_LIMIT = 16;

  function selectAddOns(input) {
    input = input || {};
    var addOns = input.addOns || [];
    var limit = input.limit == null ? ADD_ON_DEFAULT_LIMIT : Number(input.limit);
    var inCart = {};
    (input.lines || []).forEach(function (line) {
      if (line && line.productId != null) inCart[String(line.productId)] = true;
    });
    return addOns.filter(function (a) {
      if (!a || a.variantId == null || a.variantId === "") return false;
      if (inCart[String(a.productId)]) return false;
      if (!(Number(a.pricePence) <= ADD_ON_MAX_PRICE_PENCE)) return false;
      return !isLuckyDipLine(a);
    }).slice(0, limit);
  }

  /* Row header. Within 5 pounds of free delivery it names the gap (and the dip, when the dip alone closes it). */
  var NEAR_FREE_DELIVERY_PENCE = 500;

  function rowHeadline(input) {
    input = input || {};
    var gap = Number(input.gapPence) || 0;
    if (gap > 0 && gap <= NEAR_FREE_DELIVERY_PENCE) {
      var text = "You're " + formatPounds(gap) + " from free delivery.";
      if (input.hasDip && gap <= (Number(input.dipPricePence) || 0)) text += " A Lucky Dip gets you there.";
      return text;
    }
    return "Finish the look";
  }

  /* The row header already carries the free delivery sentence, so the dip tile keeps to one short line. */
  var DIP_TILE_LINE = "A surprise piece, any style.";

  /* Everything the Add-ons row shows: the dip tile (or null), the add-on tiles and the header. Null hides the row. */
  function buildRow(input) {
    input = input || {};
    var lines = input.lines || [];
    if (!lines.length) return null;

    var dip = selectOffer(input);
    var addOns = selectAddOns({ lines: lines, addOns: input.addOns, limit: input.limit });
    if (!dip && !addOns.length) return null;

    if (dip) dip.tileLine = DIP_TILE_LINE;
    var gapPence = freeDeliveryGap(input);
    return {
      headline: rowHeadline({ gapPence: gapPence, dipPricePence: dip ? dip.pricePence : 0, hasDip: !!dip }),
      dip: dip,
      addOns: addOns,
      gapPence: gapPence
    };
  }

  /* Arrow buttons for the row: enabled while there is more to scroll that way (1px slack for sub-pixel scroll ends). */
  function scrollButtonState(input) {
    var left = Number(input.scrollLeft) || 0;
    var maxLeft = (Number(input.scrollWidth) || 0) - (Number(input.clientWidth) || 0);
    return { canPrev: left > 1, canNext: maxLeft - left > 1 };
  }

  /* cart_addons_eligible fires for both arms; that is what makes the holdout comparison work. */
  function addOnsEligibleProps(row, arm, totalPence) {
    return {
      arm: arm,
      dip_shown: !!row.dip,
      addon_count: row.addOns.length,
      gap_pence: row.gapPence,
      cart_total_pence: Number(totalPence) || 0
    };
  }

  function addOnAddedProps(addOn, index, arm) {
    return {
      product_id: Number(addOn.productId),
      variant_id: Number(addOn.variantId),
      product_type: addOn.productType,
      price_pence: Number(addOn.pricePence),
      position: index + 1,
      arm: arm
    };
  }

  function formatPounds(pence, options) {
    var p = Math.round(Number(pence) || 0);
    var sign = String.fromCharCode(163); /* pound sign, kept ASCII-safe */
    if (options && options.wholeWithoutDecimals && p % 100 === 0) return sign + p / 100;
    return sign + (p / 100).toFixed(2);
  }

  /* FNV-1a 32-bit hash of the seed, reduced to 0-99. */
  function holdoutBucket(seed) {
    var str = String(seed == null ? "" : seed);
    var hash = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0) % 100;
  }

  function holdoutArm(seed) {
    return holdoutBucket(seed) < HOLDOUT_PERCENT ? "holdout" : "shown";
  }

  function randomId() {
    var cryptoObj = typeof crypto !== "undefined" ? crypto : null;
    if (cryptoObj && typeof cryptoObj.randomUUID === "function") return cryptoObj.randomUUID();
    return "ld" + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }

  function getOrCreateSeed(storage) {
    try {
      var existing = storage.getItem(SEED_KEY);
      if (existing) return existing;
    } catch (e) {
      return randomId();
    }
    var seed = randomId();
    try {
      storage.setItem(SEED_KEY, seed);
    } catch (e) { /* storage full or blocked: the seed only lasts this page view */ }
    return seed;
  }

  /* True the first time a key is seen (storage plus in-memory fallback). */
  function claimOnce(storage, key, memo) {
    if (memo && memo.has(key)) return false;
    if (memo) memo.add(key);
    try {
      if (storage.getItem(key)) return false;
      storage.setItem(key, "1");
    } catch (e) { /* blocked storage: the memo still dedupes within this page */ }
    return true;
  }

  /*
   * The events the theme's own product form fires after an add (theme.js): variant:add on the form, then
   * cart:change on <html>. cart:change is what re-renders the drawer, count and free delivery bar.
   */
  function cartEventsAfterAdd(addResponse, cartContent) {
    var cart = Object.assign({}, cartContent, { sections: addResponse.sections });
    var items = Object.prototype.hasOwnProperty.call(addResponse, "items") ? addResponse.items : [addResponse];
    return [
      { type: "variant:add", target: "element", detail: { items: items, cart: cart } },
      { type: "cart:change", target: "documentElement", detail: { baseEvent: "variant:add", cart: cart } }
    ];
  }

  /* ------------------------------------------------------------------------
   * Browser custom element. Thin: all decisions live in the functions above.
   * ---------------------------------------------------------------------- */
  var eligibleMemo = typeof Set !== "undefined" ? new Set() : null;

  function safeStorage(name) {
    try { return window[name]; } catch (e) { return null; }
  }

  function track(event, props) {
    try {
      if (window.posthog && window.posthog.capture) window.posthog.capture(event, props);
    } catch (e) { /* analytics must never break the cart */ }
  }

  function defineElement() {
    if (typeof customElements === "undefined" || typeof HTMLElement === "undefined") return;
    if (customElements.get("lucky-dip-offer")) return;

    var instanceCount = 0;

    class LuckyDipOffer extends HTMLElement {
      connectedCallback() {
        if (this._rendered) return;
        this._rendered = true;

        var data;
        try {
          var script = this.querySelector('script[type="application/json"]');
          data = JSON.parse(script ? script.textContent : "null");
        } catch (e) { data = null; }
        if (!data) return;

        var row = buildRow(data);
        if (!row) return;

        var arm = holdoutArm(getOrCreateSeed(safeStorage("localStorage")));
        var session = safeStorage("sessionStorage");
        var offer = row.dip;
        if (offer && claimOnce(session, "ikrush_ld_eligible_" + offer.handle, eligibleMemo)) {
          track("lucky_dip_offer_eligible", {
            arm: arm,
            dip_handle: offer.handle,
            gap_pence: offer.gapPence,
            cart_total_pence: Number(data.totalPence) || 0
          });
        }
        if (claimOnce(session, "ikrush_ld_addons_eligible", eligibleMemo)) {
          track("cart_addons_eligible", addOnsEligibleProps(row, arm, data.totalPence));
        }
        if (arm === "holdout") return;

        this._row = row;
        this._arm = arm;
        this._uid = "lucky-dip-" + (++instanceCount);
        this._render();
      }

      _render() {
        var row = this._row;
        var self = this;

        var region = document.createElement("div");
        region.className = "lucky-dip-offer__row";
        region.setAttribute("role", "region");

        var headline = document.createElement("p");
        headline.className = "lucky-dip-offer__headline";
        headline.id = this._uid + "-headline";
        headline.textContent = row.headline;
        region.setAttribute("aria-labelledby", headline.id);

        var scroller = document.createElement("ul");
        scroller.className = "lucky-dip-offer__scroller";
        scroller.setAttribute("tabindex", "0");
        scroller.setAttribute("aria-label", "Add-ons, scroll for more");

        if (row.dip) scroller.appendChild(this._dipTile(row.dip));
        row.addOns.forEach(function (addOn, index) {
          scroller.appendChild(self._addOnTile(addOn, index));
        });

        var header = document.createElement("div");
        header.className = "lucky-dip-offer__header";
        header.appendChild(headline);
        header.appendChild(this._scrollNav(scroller));

        region.appendChild(header);
        region.appendChild(scroller);
        this.appendChild(region);
      }

      /* Prev/next arrows for mouse and trackpad users; touch users swipe. Hidden when the row does not overflow. */
      _scrollNav(scroller) {
        var nav = document.createElement("div");
        nav.className = "lucky-dip-offer__nav";
        nav.hidden = true;

        function arrow(direction, label, glyph) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "lucky-dip-offer__arrow";
          button.setAttribute("aria-label", label);
          button.textContent = glyph;
          button.addEventListener("click", function () {
            scroller.scrollBy({ left: direction * Math.max(120, scroller.clientWidth * 0.8), behavior: "smooth" });
          });
          nav.appendChild(button);
          return button;
        }

        var prev = arrow(-1, "Previous add-ons", String.fromCharCode(8249));
        var next = arrow(1, "More add-ons", String.fromCharCode(8250));

        function update() {
          var state = scrollButtonState({ scrollLeft: scroller.scrollLeft, scrollWidth: scroller.scrollWidth, clientWidth: scroller.clientWidth });
          prev.disabled = !state.canPrev;
          next.disabled = !state.canNext;
          nav.hidden = !state.canPrev && !state.canNext;
        }

        scroller.addEventListener("scroll", update, { passive: true });
        if (typeof ResizeObserver !== "undefined") new ResizeObserver(update).observe(scroller);
        requestAnimationFrame(update);
        return nav;
      }

      _tileError() {
        var error = document.createElement("p");
        error.className = "lucky-dip-offer__error";
        error.setAttribute("role", "alert");
        error.hidden = true;
        return error;
      }

      _price(pence) {
        var price = document.createElement("p");
        price.className = "lucky-dip-offer__price";
        price.textContent = formatPounds(pence);
        return price;
      }

      _addOnTile(addOn, index) {
        var self = this;
        var tile = document.createElement("li");
        tile.className = "lucky-dip-offer__tile";

        var url = typeof addOn.url === "string" && addOn.url.charAt(0) === "/" ? addOn.url : null;
        var media = document.createElement(url ? "a" : "div");
        media.className = "lucky-dip-offer__media";
        if (url) media.href = url;
        if (typeof addOn.image === "string" && addOn.image) {
          var img = document.createElement("img");
          img.src = addOn.image;
          img.alt = String(addOn.title || "");
          img.loading = "lazy";
          img.width = 240;
          img.height = 240;
          media.appendChild(img);
        } else if (url) {
          media.setAttribute("aria-label", String(addOn.title || ""));
        }

        var title = document.createElement("p");
        title.className = "lucky-dip-offer__name";
        title.textContent = String(addOn.title || "");

        var button = document.createElement("button");
        button.type = "button";
        button.className = "lucky-dip-offer__button button button--sm";
        button.textContent = "+ Add";
        button.setAttribute("aria-label", "Add " + String(addOn.title || "") + " to bag");

        var error = this._tileError();
        button.addEventListener("click", function () {
          self._addVariant(String(addOn.variantId), button, error, "Sorry, that just sold out.", function () {
            track("cart_addon_added", addOnAddedProps(addOn, index, self._arm));
          });
        });

        tile.appendChild(media);
        tile.appendChild(title);
        tile.appendChild(this._price(addOn.pricePence));
        tile.appendChild(button);
        tile.appendChild(error);
        return tile;
      }

      _dipTile(offer) {
        var self = this;

        var card = document.createElement("li");
        card.className = "lucky-dip-offer__tile lucky-dip-offer__tile--dip";

        var title = document.createElement("p");
        title.className = "lucky-dip-offer__title";
        title.textContent = "Lucky Dip";

        var message = document.createElement("p");
        message.className = "lucky-dip-offer__message";
        message.textContent = offer.tileLine;

        var fieldset = document.createElement("fieldset");
        fieldset.className = "lucky-dip-offer__sizes";
        var legend = document.createElement("legend");
        legend.className = "sr-only";
        legend.textContent = "Choose a Lucky Dip size";
        fieldset.appendChild(legend);

        offer.variants.forEach(function (variant) {
          var inputId = self._uid + "-" + variant.id;
          var radio = document.createElement("input");
          radio.type = "radio";
          radio.name = self._uid + "-size";
          radio.id = inputId;
          radio.value = String(variant.id);
          radio.className = "lucky-dip-offer__radio";
          radio.setAttribute("data-size", String(variant.size));
          if (variant.id === offer.preselectedVariantId) radio.checked = true;

          var label = document.createElement("label");
          label.htmlFor = inputId;
          label.className = "lucky-dip-offer__pill";
          label.textContent = String(variant.size);
          label.setAttribute("aria-label", "Size " + variant.size);

          fieldset.appendChild(radio);
          fieldset.appendChild(label);
        });

        var button = document.createElement("button");
        button.type = "button";
        button.className = "lucky-dip-offer__button button button--sm";
        button.textContent = "Add";
        button.setAttribute("aria-label", "Add a Lucky Dip to bag");
        button.disabled = offer.preselectedVariantId == null;

        var error = this._tileError();

        fieldset.addEventListener("change", function () {
          button.disabled = false;
          error.hidden = true;
        });
        button.addEventListener("click", function () {
          var checked = fieldset.querySelector("input:checked");
          if (!checked) return;
          var variantId = checked.value;
          var size = checked.getAttribute("data-size");
          self._addVariant(variantId, button, error, "Sorry, that size just sold out.", function () {
            track("lucky_dip_offer_added", {
              dip_handle: offer.handle,
              variant_id: Number(variantId),
              size: size,
              arm: self._arm
            });
          });
        });

        if (offer.image) {
          var media = document.createElement("div");
          media.className = "lucky-dip-offer__media";
          var img = document.createElement("img");
          img.src = offer.image;
          img.alt = "Lucky Dip";
          img.loading = "lazy";
          img.width = 400;
          img.height = 400;
          media.appendChild(img);
          card.appendChild(media);
        }
        card.appendChild(title);
        card.appendChild(this._price(offer.pricePence));
        card.appendChild(message);
        card.appendChild(fieldset);
        card.appendChild(button);
        card.appendChild(error);
        return card;
      }

      /* Shared add flow for every tile: same request and events as the theme's own product form. */
      _addVariant(variantId, button, error, failText, onAdded) {
        var self = this;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        error.hidden = true;

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

        var formData = new FormData();
        formData.set("id", variantId);
        formData.set("quantity", "1");
        formData.set("sections", sectionsToBundle.join(","));
        formData.set("sections_url", root + "variants/" + variantId);

        var added = false;

        function fail() {
          if (added) {
            /* Added, but reading the cart failed: let the theme refresh itself. */
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            return;
          }
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          button.removeAttribute("aria-busy");
          button.disabled = false;
          error.textContent = failText;
          error.hidden = false;
        }

        fetch(root + "cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        })
          .then(function (response) {
            return response.json().then(function (json) {
              if (!response.ok) throw new Error("add failed");
              added = true;
              return json;
            });
          })
          .then(function (responseJson) {
            return fetch(root + "cart.js")
              .then(function (r) { return r.json(); })
              .then(function (cartContent) {
                document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
                button.removeAttribute("aria-busy");
                onAdded();
                cartEventsAfterAdd(responseJson, cartContent).forEach(function (e) {
                  var target = e.target === "documentElement" ? document.documentElement : self;
                  target.dispatchEvent(new CustomEvent(e.type, { bubbles: true, detail: e.detail }));
                });
              });
          })
          .catch(fail);
      }
    }

    customElements.define("lucky-dip-offer", LuckyDipOffer);
  }

  defineElement();

  var api = {
    cartEventsAfterAdd: cartEventsAfterAdd,
    claimOnce: claimOnce,
    holdoutBucket: holdoutBucket,
    holdoutArm: holdoutArm,
    getOrCreateSeed: getOrCreateSeed,
    isShoeLine: isShoeLine,
    isLuckyDipLine: isLuckyDipLine,
    selectOffer: selectOffer,
    selectAddOns: selectAddOns,
    scrollButtonState: scrollButtonState,
    rowHeadline: rowHeadline,
    buildRow: buildRow,
    addOnsEligibleProps: addOnsEligibleProps,
    addOnAddedProps: addOnAddedProps,
    formatPounds: formatPounds,
    normaliseShoeSize: normaliseShoeSize
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;
})();
